import type { FaireProductEntity } from "../../entity_types/product";

export const p_kmewcee2yd: FaireProductEntity = {
  token: "p_kmewcee2yd",
  type: "product",
  name: "Tomato Picnic Love and Friendship Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/66327ae628ca3c79e19c1195c7e14032abb528b73f69cb0ef4a5444a21d53acf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/489a3a804e03b93ba26e5fe47044c511f27b0f0818b4dc47147e4874f4defa32.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:39.559Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
